import { Compound, styled } from '@moleculeone/ui';

const Container = styled('div', {
  width: 180,
  wordBreak: 'break-all',
  padding: '$3',
  fontSize: '$1',
  fontWeight: 300,
  textAlign: 'center',
  backgroundColor: '$slate2',
  borderRadius: '$small',
});
const CompoundImage = styled('div', {
  mixBlendMode: 'darken',
  marginBottom: '$5',
});

export const ConditionCompoundPreview = ({ item }) => (
  <Container>
    {item.smiles && (
      <CompoundImage>
        <Compound smiles={item.smiles} />
      </CompoundImage>
    )}
  </Container>
);
